import formatPhone from 'src/functions/formatPhone'
import { RUSSIAN_PHONES } from 'src/functions/formatPhone/tests/russian-phones'
import { CIS_PHONES } from 'src/functions/formatPhone/tests/cis-phones'
import { Country } from 'src/types/country'

describe('Форматирование номера телефона по стране', () => {
  describe('Если передано значение с типом отличным от строки или числа', () => {
    test('Тогда возвращается это же значение', () => {
      const phones = [
        null,
        {},
        undefined,
        () => {},
        [],
        Symbol('12'),
      ]

      phones.forEach(phone => {
        expect(typeof phone).not.toBe('string')
        expect(typeof phone).not.toBe('number')
        expect(formatPhone({ phone })).toStrictEqual(phone)
      })
    })
  })
  describe('Если передано значение с типом числа и десятичным значением', () => {
    test('Тогда возвращается оно же', () => {
      const phones = [
        819188888.32,
        891819946.05,
      ]

      phones.forEach(phone => {
        expect(formatPhone({ phone })).toStrictEqual(phone)
      })
    })
  })
  describe('Если передано значение с типом строки или числа', () => {
    describe('Если страна не передана', () => {
      test('Тогда возвращается форматирование для России', () => {
        RUSSIAN_PHONES.forEach(({ phone, formatted }) => {
          expect(formatPhone({ phone })).toStrictEqual(formatted)
        })
        RUSSIAN_PHONES.forEach(({ phone, raw }) => {
          expect(formatPhone({ phone, isRaw: true })).toStrictEqual(raw)
        })
      })
    })
    describe('Если страна - Россия', () => {
      test('Тогда возвращается форматирование для России', () => {
        RUSSIAN_PHONES.forEach(({ phone, formatted }) => {
          expect(formatPhone({
            phone,
            country: {
              iso: 'ru',
            },
          })).toBe(formatted)
        })
        RUSSIAN_PHONES.forEach(({ phone, raw }) => {
          expect(formatPhone({
            phone,
            country: {
              iso: 'ru',
            },
            isRaw: true,
          })).toBe(raw)
        })
        RUSSIAN_PHONES.forEach(({ phone, formatted }) => {
          expect(formatPhone({
            phone,
            country: {
              iso: 'ru',
            },
          })).toBe(formatted)
        })
        RUSSIAN_PHONES.forEach(({ phone, raw }) => {
          expect(formatPhone({
            phone,
            country: {
              iso: 'ru',
            },
            isRaw: true,
          })).toBe(raw)
        })
      })
      test.each([
        '7',
        '+7',
        '++7',
      ])('Тогда phone_code %s даёт один плюс в номере', phoneCode => {
        expect(formatPhone({
          phone: '861 203-39-08',
          country: {
            iso: 'ru',
            phone_code: phoneCode,
          },
        })).toBe('+7 861 203-39-08')
      })
      test.each([
        '7',
        '+7',
        '++7',
      ])('Тогда 8-800 с phone_code %s без плюса', phoneCode => {
        expect(formatPhone({
          phone: '8 (800) 555-35-35',
          country: {
            iso: 'ru',
            phone_code: phoneCode,
          },
          normalizePhoneCode: true,
        })).toBe('8 800 555-35-35')
      })
    })
    describe('Если страна - не Россия', () => {
      test('Тогда возвращается форматирование для этой страны', () => {
        Object.keys(CIS_PHONES).forEach(countryIso => {
          CIS_PHONES[countryIso as keyof typeof CIS_PHONES].forEach(({ phone, formatted }) => {
            expect(formatPhone({
              phone,
              country: {
                iso: countryIso as Country['iso'],
              },
            })).toBe(formatted)
          })
        })
        Object.keys(CIS_PHONES).forEach(countryIso => {
          CIS_PHONES[countryIso as keyof typeof CIS_PHONES].forEach(({ phone, raw }) => {
            expect(formatPhone({
              phone,
              country: {
                iso: countryIso as Country['iso'],
              },
              isRaw: true,
            })).toBe(raw)
          })
        })
      })
    })
  })
})
